import BackButtonToolbar from "features/BackButtonToolbar";
import InactiveDeleteOptionEditToolbar from "features/EditToolbar";
import React from "react";
import { Create, SimpleForm, useNotify, useRedirect, useStore } from "react-admin";
import CreateForm from "./CreateForm";
import useConflictErrorModal from "server/components/Modals/useConflictErrorModal";
import { GraduationServicePath, STATE_EXAMS } from "utils/constants";
import { errorMessages } from "app";

const STORE_KEY = "internshipStateExams.filters";

const CreateSingleStateExams = () => {
  const [filters] = useStore(STORE_KEY, null);
  const { handleConflictError, ConflictErrorDialog } = useConflictErrorModal();
  const notify = useNotify();
  const redirect = useRedirect();

  const transform = data => ({
    stateExamId: data.stateExamId,
    assignmentType: data.assignmentType,
    examTimestamp: data.examTimestamp,
    roomId: data.roomId,
    commissions: data.commissions,
    studyGroups: data.studyGroups,
    internshipSessionId: data.internshipSessionId,
    specialityId: data.specialityId,
  });

  const onSuccess = () => {
    notify("Успешно създаване на държавен изпит", { type: "success" });
    redirect(`/${GraduationServicePath}${STATE_EXAMS}`);
  };

  return (
    <>
      <Create
        resource={`${GraduationServicePath}${STATE_EXAMS}/single`}
        title="Създавне на единичен изпит"
        actions={<BackButtonToolbar />}
        transform={transform}
        onError={e => {
          const errorMessage = e.message || errorMessages[e.errorCode];
          notify(errorMessage, { type: "error" });
          handleConflictError(e);
        }}
        mutationOptions={{ onSuccess }}
      >
        <SimpleForm
          toolbar={<InactiveDeleteOptionEditToolbar />}
          defaultValues={{
            academicYearId: filters?.academicYearId,
            structuralUnitId: filters?.structuralUnitId,
            internshipSessionId: filters?.internshipSessionId,
          }}
        >
          <CreateForm filters={filters} />
        </SimpleForm>
      </Create>
      <ConflictErrorDialog />
    </>
  );
};

export default CreateSingleStateExams;
